import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from '../header/header';
import Footer from '../footer/footer';
import { Box, makeStyles, IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { connect, useDispatch } from "react-redux";
import { getSignedUserData } from '../../store/actions/user/user_action';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import { SnackbarProvider } from 'notistack';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    },
    icon: {
        color: '#fff'
    }
});

const Layout = ({ user, children }) => {
    const { root, icon } = useStyles();
    const dispatch = useDispatch();

    const userObjectKeys = Object.keys(user);

    useEffect(() => {
        if (userObjectKeys.length <= 1) {
            return getSignedUserData(dispatch);
        }
        history.push(REACT_ROUTES.SCHEDULER);
    }, []);

    const notistackRef = useRef(null);
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }

    return (
        <Box className={root}>
            {userObjectKeys.length > 1 &&
                <>
                    <Header />
                    <Box>
                        <SnackbarProvider
                            ref={notistackRef}
                            maxSnack={3}
                            preventDuplicate
                            action={(key) => (
                                <IconButton onClick={onClickDismiss(key)}>
                                    <Clear className={icon} />
                                </IconButton>
                            )}
                        >
                            {children}
                        </SnackbarProvider>
                    </Box>
                    <Footer />
                </>
            }
        </Box>
    )
};

Layout.propTypes = {
    children: PropTypes.any.isRequired,
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(Layout);
